<template>
<Head title="Termos de Uso" />
    <Authenticated>
        <HeaderComponent :showExtras="false" />

            <Heading title="Termos de Uso" class="xl:px-[16vw] pt-24 sm:pl-6 sm:pt-28"/>
            <div class="p-4 px-5 xl:px-[16vw] min-h-[70vh]">
                <div v-html="term.text"></div>
            </div>
    </Authenticated>
</template>
<script>
import Authenticated from '@/Layouts/Authenticated.vue'
import { Head } from '@inertiajs/inertia-vue3';
import Heading from '@/Components/UI/Texts/Heading.vue'

export default {
    components:{
        Authenticated,
        Head,
        Heading,
    },

    props: {
        term: Object,
    },

    methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
}
</script>
<style scoped>
table {
    border: 2px black;
    border-style: solid;
}
</style>
